import { define } from './define';

// The frame around every page: sidebar, brand switcher, notifications, account menu.
export const layout = define({
  es: {
    'layout.home': 'Inicio de Postbay',
    'layout.nav.home': 'Para ti',
    'layout.allPieces': 'Todas',
    'layout.collections': 'Colecciones',
    'layout.collection.in_review': 'Por revisar',
    'layout.collection.agent': 'Del agente',
    'layout.collection.changes_requested': 'Cambios pedidos',
    'layout.collection.approved': 'Aprobadas',
    'layout.collection.draft': 'Borradores',
    'layout.newCampaign': 'Nueva campaña',
    'layout.newBrand': 'Nueva marca',
    'layout.newBrandHint': 'Una marca tiene sus propias cuentas, miembros, campañas y calendario. Entrarás como administrador; a los demás los añades después.',
    'layout.brandName': 'Nombre de la marca',
    'layout.brandTimezone': 'Zona horaria',
    'layout.brandTimezoneHint': 'Las horas de publicación y los huecos van en esta zona.',
    'layout.brandLanguage': 'Idioma de los avisos',
    'layout.brandLanguageHint': 'En el que la app escribe los correos y los avisos de esta marca.',
    'layout.createBrand': 'Crear marca',
    'layout.campaignName': 'Nombre de la campaña',
    'layout.palette.title': 'Buscar',
    'layout.palette.placeholder': 'Busca una pieza o escribe qué quieres hacer…',
    'layout.palette.placeholderShort': 'Buscar piezas y acciones',
    'layout.palette.empty': 'Nada coincide.',
    'layout.palette.move': 'moverse',
    'layout.palette.open': 'abrir',
    'layout.palette.group.pieces': 'Piezas',
    'layout.palette.group.go': 'Ir a',
    'layout.palette.group.actions': 'Acciones',
    'layout.palette.switchBrand': 'Cambiar a {brand}',
    'layout.palette.language': 'Idioma: {language}',

    'layout.appName': 'Postbay',
    'layout.nav.main': 'Principal',
    'layout.nav.pieces': 'Piezas',
    'layout.nav.calendar': 'Calendario',
    'layout.nav.publish': 'Publicar hoy',
    'layout.nav.results': 'Resultados',
    'layout.nav.settings': 'Ajustes',
    'layout.brands': 'Marcas',
    'layout.brand': 'Marca',
    'layout.paused': 'Esta marca está en pausa: no se publica, programa ni mueve nada hasta reanudarla.',
    'layout.account': 'Tu cuenta',
    'layout.accountHint': '{email}: avisos e inicio de sesión',
    'layout.signOut': 'Cerrar sesión',
    'layout.language': 'Idioma',
    'layout.menu': 'Menú',
    'layout.noBrands': 'Todavía no perteneces a ninguna marca',
    'layout.noBrandsHint': 'Pide a un administrador que añada {email} a una marca.',

    'notif.title': 'Avisos',
    'notif.button': 'Avisos',
    'notif.buttonUnread': { one: 'Avisos, {count} sin leer', other: 'Avisos, {count} sin leer' },
    'notif.markAll': 'Marcar todo como leído',
    'notif.empty': 'Nada por ahora.',
    'notif.kind.version.uploaded': 'Versión nueva para revisar',
    'notif.kind.comment.created': 'Comentario nuevo',
    'notif.kind.version.changes_requested': 'Cambios pedidos',
    'notif.kind.version.approved': 'Versión aprobada',
    'notif.kind.publication.due': 'Hay una publicación para hoy',
    'notif.kind.publication.reapproval': 'Un cambio necesita tu confirmación',
    'notif.kind.publication.on_hold': 'Una versión nueva ha dejado publicaciones en espera',
    'notif.kind.publication.published': 'Se ha publicado un post',
    'notif.kind.publication.failed': 'No se ha podido publicar un post',
    'notif.kind.publication.private': 'Un vídeo ha quedado privado: hay que hacerlo público',
    'notif.kind.account.reconnect': 'Hay que volver a conectar una cuenta',
    'notif.kind.account.expiring': 'Una conexión está a punto de caducar',
    'notif.kind.webhook.failing': 'Un webhook está fallando',
    'notif.kind.agent.needs_person': 'El agente ha devuelto una pieza a una persona',
    'notif.kind.digest.weekly': 'Los posts de la semana que viene están listos',
    'notif.kind.slot.unapproved': 'Un post sale en menos de un día y no está aprobado',
    'notif.kind.results.due': 'Apunta los números de un post que publicaste a mano',
    'notif.kind.agent.failed': 'Ha fallado una ejecución del agente',
  },
  en: {
    'layout.home': 'Postbay home',
    'layout.nav.home': 'For you',
    'layout.allPieces': 'All pieces',
    'layout.collections': 'Collections',
    'layout.collection.in_review': 'To review',
    'layout.collection.agent': 'From the agent',
    'layout.collection.changes_requested': 'Changes requested',
    'layout.collection.approved': 'Approved',
    'layout.collection.draft': 'Drafts',
    'layout.newCampaign': 'New campaign',
    'layout.newBrand': 'New brand',
    'layout.newBrandHint': 'A brand has its own accounts, members, campaigns and calendar. You will join as its admin; add the others afterwards.',
    'layout.brandName': 'Brand name',
    'layout.brandTimezone': 'Time zone',
    'layout.brandTimezoneHint': 'Publishing times and slots use this zone.',
    'layout.brandLanguage': 'Language for notifications',
    'layout.brandLanguageHint': 'The language the app writes this brand’s emails and notifications in.',
    'layout.createBrand': 'Create brand',
    'layout.campaignName': 'Campaign name',
    'layout.palette.title': 'Search',
    'layout.palette.placeholder': 'Find a piece or type what you want to do…',
    'layout.palette.placeholderShort': 'Search pieces and actions',
    'layout.palette.empty': 'Nothing matches.',
    'layout.palette.move': 'move',
    'layout.palette.open': 'open',
    'layout.palette.group.pieces': 'Pieces',
    'layout.palette.group.go': 'Go to',
    'layout.palette.group.actions': 'Actions',
    'layout.palette.switchBrand': 'Switch to {brand}',
    'layout.palette.language': 'Language: {language}',

    'layout.appName': 'Postbay',
    'layout.nav.main': 'Main',
    'layout.nav.pieces': 'Pieces',
    'layout.nav.calendar': 'Calendar',
    'layout.nav.publish': 'Publish today',
    'layout.nav.results': 'Results',
    'layout.nav.settings': 'Settings',
    'layout.brands': 'Brands',
    'layout.brand': 'Brand',
    'layout.paused': 'This brand is paused: nothing is published, scheduled or moved until it is resumed.',
    'layout.account': 'Your account',
    'layout.accountHint': '{email}: notifications and sign-in',
    'layout.signOut': 'Sign out',
    'layout.language': 'Language',
    'layout.menu': 'Menu',
    'layout.noBrands': 'You are not a member of any brand yet',
    'layout.noBrandsHint': 'Ask an admin to add {email} to a brand.',

    'notif.title': 'Notifications',
    'notif.button': 'Notifications',
    'notif.buttonUnread': { one: 'Notifications, {count} unread', other: 'Notifications, {count} unread' },
    'notif.markAll': 'Mark all read',
    'notif.empty': 'Nothing yet.',
    'notif.kind.version.uploaded': 'New version ready for review',
    'notif.kind.comment.created': 'New comment',
    'notif.kind.version.changes_requested': 'Changes requested',
    'notif.kind.version.approved': 'Version approved',
    'notif.kind.publication.due': 'A publication is due',
    'notif.kind.publication.reapproval': 'A change needs your confirmation',
    'notif.kind.publication.on_hold': 'Scheduled posts put on hold by a new version',
    'notif.kind.publication.published': 'A post went out',
    'notif.kind.publication.failed': 'A post could not be published',
    'notif.kind.publication.private': 'A video is private: it needs making public',
    'notif.kind.account.reconnect': 'An account needs reconnecting',
    'notif.kind.account.expiring': 'An account connection is about to expire',
    'notif.kind.webhook.failing': 'A webhook is failing',
    'notif.kind.agent.needs_person': 'The agent handed a piece back to a person',
    'notif.kind.digest.weekly': "Next week's posts are ready",
    'notif.kind.slot.unapproved': 'A post goes out within a day and is not approved',
    'notif.kind.results.due': 'Enter the numbers of a post you published by hand',
    'notif.kind.agent.failed': 'An agent run failed',
  },
});
